export default {
  
  beforeMount( el, binding ) {

    const position = binding.value.position || 'bottom';
    const text = binding.value.text || '';
    const classList = "tooltip tooltip__arrow tooltip__arrow--state-" + position; 

    const tooltip = document.createElement('div');
    tooltip.classList = classList;
    tooltip.style[position] = '100%';
    tooltip.append(text);

    el.appendChild(tooltip);
    el.classList.add('has-tooltip');

    el.addEventListener('keydown', (event) => {
      if(event.keyCode === 27){
        el.classList.add('hide-tooltip');
      }
    });

    el.addEventListener('focusout', () => {
      el.classList.remove('hide-tooltip');
    });

    if(el.style[position] === '' || el.style[position] === 'static'){
        el.style.position = 'relative';
    }
  },
}

